export class ScheduleSharingInput {

  user!: string;
  scheduleId!: string;
  organizationId!: string;
  notificationUser!: string;

}
